var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%", height: "100%" } },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "el-table-infinite-scroll",
              rawName: "v-el-table-infinite-scroll",
              value: _vm.config.loadList,
              expression: "config.loadList",
            },
          ],
          staticClass: "scpc-task-table",
          style: {
            width:
              _vm.type === "examine"
                ? "calc(100% - 35px)"
                : "calc(100% - 235px)",
            height: _vm.tableHeight,
          },
          attrs: {
            "row-key": "id",
            data: _vm.table_config.tableData,
            "header-cell-style": {
              background: "#F1F1F1 ",
              fontSize: "14px",
              color: "#999999",
            },
            "cell-style": {
              fontSize: "14px",
            },
            "row-style": { height: "38" },
          },
          on: { "cell-click": _vm.cellClick },
        },
        [
          [
            _vm._l(_vm.table_config.thead, function (item) {
              return [
                item.prop === "meritsDate"
                  ? _c("el-table-column", {
                      key: item.prop,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        "render-header": item.render_header,
                        width: "120",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "scope-content-id" },
                                  [_vm._v(_vm._s(scope.row.meritsDate))]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e(),
                item.prop === "meritsUserModel"
                  ? _c("el-table-column", {
                      key: item.prop,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        "render-header": item.render_header,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", [
                                  _vm.channel === "wechat"
                                    ? _c(
                                        "span",
                                        [
                                          _c("ww-open-data", {
                                            attrs: {
                                              type: "userName",
                                              openid:
                                                scope.row.meritsUserModel.name,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.meritsUserModel.name)
                                        ),
                                      ]),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : item.prop === "currentFlowName"
                  ? _c("el-table-column", {
                      key: item.prop,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        "render-header": item.render_header,
                        "min-width": "130",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                    style:
                                      "color: " + scope.row.currentFlowColor,
                                  },
                                  [
                                    _c("span", {}, [
                                      _vm._v(_vm._s(scope.row.currentFlowName)),
                                    ]),
                                    scope.row.currentUserList &&
                                    scope.row.currentUserList.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.type === "examine",
                                                expression:
                                                  "type === 'examine'",
                                              },
                                            ],
                                          },
                                          _vm._l(
                                            scope.row.currentUserList,
                                            function (item1, index) {
                                              return _c("div", { key: index }, [
                                                _vm._v(" ( "),
                                                _vm.channel === "wechat"
                                                  ? _c(
                                                      "span",
                                                      [
                                                        _c("ww-open-data", {
                                                          attrs: {
                                                            type: "userName",
                                                            openid: item1.name,
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(item1.name)
                                                      ),
                                                    ]),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          scope.row
                                                            .currentUserList
                                                            .length -
                                                            1 !=
                                                          index,
                                                        expression:
                                                          "scope.row.currentUserList.length-1!=index",
                                                      },
                                                    ],
                                                  },
                                                  [_vm._v(",")]
                                                ),
                                                _vm._v(") "),
                                              ])
                                            }
                                          ),
                                          0
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : item.prop === "currentUser"
                  ? _c("el-table-column", {
                      key: item.prop,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        "render-header": item.render_header,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.currentUserList &&
                                scope.row.currentUserList.length > 0
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        scope.row.currentUserList,
                                        function (item1, index) {
                                          return _c("div", { key: index }, [
                                            _vm.channel === "wechat"
                                              ? _c(
                                                  "span",
                                                  [
                                                    _c("ww-open-data", {
                                                      attrs: {
                                                        type: "userName",
                                                        openid: item1.name,
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _c("span", [
                                                  _vm._v(_vm._s(item1.name)),
                                                ]),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      scope.row.currentUserList
                                                        .length -
                                                        1 !=
                                                      index,
                                                    expression:
                                                      "scope.row.currentUserList.length-1!=index",
                                                  },
                                                ],
                                              },
                                              [_vm._v(",")]
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  : _c("div", { staticClass: "table_none" }, [
                                      _vm._v("-"),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : item.prop === "realityScore"
                  ? _c("el-table-column", {
                      key: item.prop,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        "render-header": item.render_header,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", [
                                  _vm._v(_vm._s(scope.row.realityScore)),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : item.prop === "gradeName"
                  ? _c("el-table-column", {
                      key: item.prop,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        "render-header": item.render_header,
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { cursor: "pointer" } },
                                  [
                                    _c("span", [
                                      scope.row.gradeName
                                        ? _c(
                                            "span",
                                            {
                                              style: scope.row.gradeColor
                                                ? "color: " +
                                                  scope.row.gradeColor
                                                : "color: #2878ff",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row.gradeName)
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "table_none" },
                                            [_vm._v("-")]
                                          ),
                                    ]),
                                    scope.row.gradeRemark
                                      ? _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "padding-left": "5px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "(" +
                                                _vm._s(scope.row.gradeRemark) +
                                                ")"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : item.prop === "aheadCount"
                  ? _c("el-table-column", {
                      key: item.prop,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        "render-header": item.render_header,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "scope-content-id",
                                    staticStyle: {
                                      color: "#2db039",
                                      "padding-left": "21px",
                                      cursor: "pointer",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openDetail(scope.row, "1")
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.aheadCount))]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : item.prop === "normalCount"
                  ? _c("el-table-column", {
                      key: item.prop,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        "render-header": item.render_header,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "scope-content-id",
                                    staticStyle: {
                                      color: "#2878ff",
                                      "padding-left": "21px",
                                      cursor: "pointer",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openDetail(scope.row, "0")
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.normalCount))]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : item.prop === "extensCount"
                  ? _c("el-table-column", {
                      key: item.prop,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        "render-header": item.render_header,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "scope-content-id",
                                    staticStyle: {
                                      color: "#dd483f",
                                      "padding-left": "21px",
                                      cursor: "pointer",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openDetail(scope.row, "2")
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.extensCount))]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : item.prop === "controls"
                  ? _c("el-table-column", {
                      key: item.prop,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        "render-header": item.render_header,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.status !== "1" &&
                                scope.row.currentUserId == _vm.UserData.userId
                                  ? _c(
                                      "el-button",
                                      { attrs: { plain: "", type: "primary" } },
                                      [_vm._v("评分")]
                                    )
                                  : _c("el-button", { attrs: { plain: "" } }, [
                                      _vm._v("查看"),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : item.prop === "reviewe"
                  ? _c("el-table-column", {
                      key: item.prop,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        "render-header": item.render_header,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.status !== "1" &&
                                scope.row.currentUserId == _vm.UserData.userId
                                  ? _c(
                                      "el-button",
                                      { attrs: { plain: "", type: "primary" } },
                                      [_vm._v("评分")]
                                    )
                                  : _c("el-button", { attrs: { plain: "" } }, [
                                      _vm._v("查看"),
                                    ]),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : item.prop === "todocontrol"
                  ? _c("el-table-column", {
                      key: item.prop,
                      attrs: {
                        prop: item.prop,
                        label: item.label,
                        "render-header": item.render_header,
                        width: "110",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.type === "examine"
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                        },
                                      },
                                      [
                                        scope.row.status !== "1" &&
                                        scope.row.submitFlag
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  plain: "",
                                                  type: "primary",
                                                },
                                              },
                                              [_vm._v("评分")]
                                            )
                                          : _c(
                                              "el-button",
                                              { attrs: { plain: "" } },
                                              [_vm._v("查看")]
                                            ),
                                        _c("div", {
                                          staticStyle: {
                                            "border-left": "1px solid #909090",
                                            width: "2px",
                                            height: "15px",
                                            margin: "0 10px",
                                          },
                                        }),
                                        _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              effect: "dark",
                                              content: "删除",
                                              placement: "top",
                                              "popper-class": "texttooltip",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "iconfont icon-shanchu1 icon_btn",
                                              staticStyle: {
                                                cursor: "pointer",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.delFollow(
                                                    scope.$index,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              plain: "",
                                              type: "primary",
                                            },
                                          },
                                          [_vm._v("评分")]
                                        ),
                                      ],
                                      1
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e(),
              ]
            }),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }